import styled from 'styled-components';
import { Card } from 'ui/card';
import { Tooltip } from 'ui/tooltip';
import { pxToRem } from 'utils/convert';
import { colors, fontSizes, smallShadow, mediumShadow, spacing } from 'ui/theme';
import { BasicFilterSelect } from 'ui/selects';

export const StyledCard = styled(Card)`
  ${smallShadow};
  background: ${colors.white};
  border-radius: ${spacing.half};
  padding-bottom: ${spacing.quarter};
  position: relative;
  outline: none;
  &:hover {
    ${mediumShadow};
  }
  ::before {
    border: ${({ hasError }) =>
      `${spacing.quarter} solid ${hasError ? colors.red100 : colors.purple50}`};
    border-radius: ${spacing.threeQuarter};
    inset: -${spacing.quarter};
    content: '';
    display: block;
    opacity: ${({ isSelected }) => (isSelected ? 1 : 0)};
    position: absolute;
    transition: all 0.2s;
  }
`;

export const PreviewContainer = styled.section`
  align-items: center;
  background: ${colors.grey5};
  border-radius: ${spacing.quarter};
  display: flex;
  height: ${pxToRem(200)};
  justify-content: center;
  margin: ${spacing.half};
  overflow: hidden;
`;

export const DetailsContainer = styled.section`
  margin: ${spacing.threeQuarter} ${spacing.base};
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: ${spacing.half};
`;

export const DetailsLabel = styled.div`
  min-width: 0;
  font-size: ${fontSizes.s15};
  line-height: ${spacing.plusHalf};
  white-space: pre;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 90%;
`;

export const DetailsLabelExtended = styled(DetailsLabel)`
  max-width: 100%;
`;

export const StyledTitleWrapper = styled.div`
  position: relative;
  text-overflow: ellipsis;
  overflow: hidden;
`;

export const StyledBasicFilterSelect = styled(BasicFilterSelect)`
  margin-top: ${spacing.half};
`;

export const StyledTooltip = styled(Tooltip)`
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  max-width: 100%;
`;

export const Flex = styled.div`
  display: flex;
  align-items: center;
  gap: ${spacing.half};
  flex-wrap: wrap;
`;
